/*
 * @Author: dgq 370541946@qq.com
 * @Date: 2025-03-12 20:07:39
 * @FilePath: /insuranceagent-ui/src/main.js
 * @Description: 主文件
 */
import 'babel-polyfill'
import 'classlist-polyfill'
import Vue from 'vue'
import axios from './router/axios'
import VueAxios from 'vue-axios'
import App from './App'
import './permission' // 权限
import './error' // 日志
import './cache' //页面缓冲
import router from './router/router'
import store from './store'
import {loadStyle} from './util/util'
import * as urls from '@/config/env'
import {iconfontUrl, iconfontVersion} from '@/config/env'
import * as filters from './filters' // 全局filter
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/common.scss'
import AvueFormDesign from '@sscfaith/avue-form-design'
import basicContainer from './components/basic-container/main'
import '@wangeditor/editor/dist/css/style.css'
import Avue from '@smallwei/avue'
import '@smallwei/avue/lib/index.css'
import {EventBus} from './util/eventBus'

// 引导插件
import 'intro.js/introjs.css' // introjs默认css样式
import baseCrud from '@/mixins/baseCrud'
import {setAxios} from 'meibao-insure/src/api/productCenterNew'

window.$baseCrud = baseCrud

// 插件 json 展示
Vue.use(router)

Vue.use(AvueFormDesign)

Vue.prototype.$Bus = EventBus

window.axios = axios
//设置请求
setAxios(axios)

Vue.use(VueAxios, axios)

Vue.use(ElementUI, {
	size: 'mini',
	menuType: 'text',
})

Vue.use(Avue, {
	size: 'mini',
	menuType: 'text',
})

// 注册全局容器
Vue.component('basicContainer', basicContainer)

// 加载相关url地址
Object.keys(urls).forEach((key) => {
	Vue.prototype[key] = urls[key]
})

Vue.prototype.envConfig = urls

// 加载过滤器
Object.keys(filters).forEach((key) => {
	Vue.filter(key, filters[key])
})

// 动态加载阿里云字体库
iconfontVersion.forEach((ele) => {
	loadStyle(iconfontUrl.replace('$key', ele))
})

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app')
